import http from "../http-common";
import {data} from "../global_variables/global_variables"

const telegramBotDataService = {
    sendMessage(name, phone) {

        const time = new Date().toLocaleDateString()

        const formattedText = `
<b>📩 Новое обращение</b>\n
<b>🗓 Дата:</b> <i>${time}</i>\n
<b>👤 Имя:</b> <i>${name}</i>\n
<b>📞 Телефон:</b> <code>${phone}</code>
`;


        return http.get(`https://api.telegram.org/bot${data.token_telegram_bot}/sendMessage`, {
            params: {
                chat_id: data.id_chat,
                text: formattedText,
                parse_mode: "HTML"
            }
        });
    },
}

export default telegramBotDataService